import React from 'react';
import { ContactForm } from '../ContactForm';
import { ContactInfoGrid } from '../shared/ContactInfoGrid';
import { contactInfo } from '../../data/mock';

export const ContactSection = () => (
  <section className="valuare-contact-section" id="contacto" data-testid="contact-section">
    <div className="valuare-contact-inner">
      <div className="valuare-section-label">Contactos Profissionais</div>
      <h2 className="valuare-section-title">
        Solicite <em>Avaliação Técnica</em>
      </h2>

      <div className="valuare-contact-person">
        <div className="valuare-contact-name">{contactInfo.name}</div>
        <div className="valuare-contact-role">{contactInfo.role}</div>
      </div>

      <ContactForm
        title="Solicitação de Avaliação Técnica"
        submitLabel="Enviar Pedido"
        whatsAppMessage="Olá! Gostaria de solicitar uma avaliação imobiliária."
      />

      <ContactInfoGrid />
    </div>
  </section>
);
